export default {
  en: {
    uploader: {
      text: 'Drag & drop your files here or',
      button: 'Select file',
    },
    dropzone: {
      hoverText: 'Drag and drop your documents here to attach them',
    },
    downloadFailed: 'Failed to download file, contact support for help',
    filesAttached: '{n} file attached | {n} files attached',
    uploadFailed: 'Failed to upload file, contact support for help',
    processing: 'Processing file',
    processingFailed: 'Failed to process file, contact support for help',
  },
};
